// Fonts are self-hosted through @fontsource rather than loaded from
// fonts.googleapis.com. An installation on a closed corporate network — the
// normal case for in-house G&G tooling — would fail to fetch an external font
// on every page load, and the fixed 1587 x 1123 px CPI sheet is sensitive to
// font metrics. Latin subset only: pulling in Cyrillic, Greek and Vietnamese
// adds twenty files this interface will never use.
import "@fontsource/ibm-plex-sans/latin-400.css";
import "@fontsource/ibm-plex-sans/latin-500.css";
import "@fontsource/ibm-plex-sans/latin-600.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth";
import "./theme.css";

const container = document.getElementById("root");
if (!container) throw new Error("Element #root not found");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
